import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './HomeSectionSubtitle.scss';

const HomeSectionSubtitle = ({ children, light, className }) => {
  const componentClasses = classNames(
    'home-section-subtitle',
    {
      'home-section-subtitle--light': light
    },
    className
  );

  return <p className={componentClasses}>{children}</p>;
};

HomeSectionSubtitle.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  light: PropTypes.bool
};

export default HomeSectionSubtitle;
